import useSWR from "swr"
import {API_ECP_PROJECTS} from "../constants/apiUrls"

export default function useEcpVerbatims(projectId) {
    const {data, mutate, error} = useSWR(`${API_ECP_PROJECTS}/${projectId}/verbatims`, {revalidateOnFocus: false})
    return {
        ecpVerbatims: data,
        mutateEcpVerbatims: mutate,
        isLoadingEcpVerbatims: !error && !data,
        isErrorEcpVerbatims: error
    }
}